import PropTypes from 'prop-types';

export default PropTypes.shape({
	advisorDisclaimer: PropTypes.string,
	businessPhone: PropTypes.string,
	cellPhone: PropTypes.string,
	companyName: PropTypes.string,
	complianceID: PropTypes.string,
	disclaimers: PropTypes.arrayOf(PropTypes.shape({
		key: PropTypes.string,
		value: PropTypes.string
	})),
	displayName: PropTypes.string,
	email: PropTypes.string,
	firstName: PropTypes.string,
	fullAddressHtml: PropTypes.string,
	lastName: PropTypes.string,
	logoUrl: PropTypes.string,
	officeFooter: PropTypes.string,
	partnerFooter: PropTypes.string,
	poweredByLogo: PropTypes.string,
	theme: PropTypes.string,
	websiteUrl: PropTypes.string
});